package com.tencent.kuikly.core.render.web.nvi.serialization.json

/**
 * JSON custom exception
 */
class JSONException : Exception {
    constructor(s: String) : super(s)
}
